
















import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import ProductIncipitInfo from './ProductIncipitInfo.vue';
import Spinner from '~/components/solepro/Spinner.vue';
import ProductIncipitInfoBook from './ProductIncipitInfoBook.vue';
import SfBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/SfBreadcrumbs.vue';
import { Breadcrumb } from '~/modules/catalog/types';
import ProductHeading from './ProductHeading.vue';

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        },
        isBook: {
            type: Boolean
        },
        breadcrumbs: {
            type: Array as PropType<Breadcrumb[]>
        }
    },
    components: {
        SfBreadcrumbs,
        ProductHeading,
        ProductIncipitInfo,
        ProductIncipitInfoBook,
        Spinner
    },
       data() {
        return {
            isSSR: true
        }
    },
    mounted() {
        setTimeout(()=>{
            this.isSSR = false
        },100) /** avoid rendering gap */
    },
    setup(props) {
        const galleryImages = (props?.product?.mediaGallery ?? []).filter(el => !el.disabled).sort((a, b) => a.position - b.position)
        const isSingleVideo = galleryImages.length == 1 && !!galleryImages[0].video_content;
        const GalleryComponent = isSingleVideo
            ? () => import('~/components/solepro/ProductPage/ProductSingleVideo.vue')
            : () => import('~/components/solepro/ProductPage/ProductGalleryIncipit.vue')
        const componentProps = isSingleVideo ? {product: props.product} : {product: props.product, isBook:props.isBook}

        return {
            hasGallery: galleryImages.length > 0,
            GalleryComponent,
            componentProps
        }
    }
})
